import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const cmsContentNewsletterSignupDefaultVariants = {}
const cmsContentNewsletterSignupCompoundVariants = []

const cmsContentNewsletterSignupSlotNames = [
  [
    "gridItem",
    "cms-newsletter-signup__gridItem"
  ],
  [
    "container",
    "cms-newsletter-signup__container"
  ],
  [
    "bgImage",
    "cms-newsletter-signup__bgImage"
  ],
  [
    "containerInner",
    "cms-newsletter-signup__containerInner"
  ],
  [
    "mainContainer",
    "cms-newsletter-signup__mainContainer"
  ],
  [
    "imageContainer",
    "cms-newsletter-signup__imageContainer"
  ],
  [
    "innerContainer",
    "cms-newsletter-signup__innerContainer"
  ],
  [
    "factsContainer",
    "cms-newsletter-signup__factsContainer"
  ],
  [
    "factsItem",
    "cms-newsletter-signup__factsItem"
  ],
  [
    "teaser",
    "cms-newsletter-signup__teaser"
  ],
  [
    "title",
    "cms-newsletter-signup__title"
  ],
  [
    "formWrapper",
    "cms-newsletter-signup__formWrapper"
  ],
  [
    "imgBox",
    "cms-newsletter-signup__imgBox"
  ],
  [
    "infoIcon",
    "cms-newsletter-signup__infoIcon"
  ],
  [
    "infoText",
    "cms-newsletter-signup__infoText"
  ],
  [
    "resIcon",
    "cms-newsletter-signup__resIcon"
  ],
  [
    "buttons",
    "cms-newsletter-signup__buttons"
  ],
  [
    "resMsg",
    "cms-newsletter-signup__resMsg"
  ],
  [
    "terms",
    "cms-newsletter-signup__terms"
  ],
  [
    "termsCheckboxText",
    "cms-newsletter-signup__termsCheckboxText"
  ],
  [
    "termsCheckboxError",
    "cms-newsletter-signup__termsCheckboxError"
  ],
  [
    "termsDialogContent",
    "cms-newsletter-signup__termsDialogContent"
  ]
]
const cmsContentNewsletterSignupSlotFns = /* @__PURE__ */ cmsContentNewsletterSignupSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, cmsContentNewsletterSignupDefaultVariants, getSlotCompoundVariant(cmsContentNewsletterSignupCompoundVariants, slotName))])

const cmsContentNewsletterSignupFn = memo((props = {}) => {
  return Object.fromEntries(cmsContentNewsletterSignupSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const cmsContentNewsletterSignupVariantKeys = []
const getVariantProps = (variants) => ({ ...cmsContentNewsletterSignupDefaultVariants, ...compact(variants) })

export const cmsContentNewsletterSignup = /* @__PURE__ */ Object.assign(cmsContentNewsletterSignupFn, {
  __recipe__: false,
  __name__: 'cmsContentNewsletterSignup',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: cmsContentNewsletterSignupVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, cmsContentNewsletterSignupVariantKeys)
  },
  getVariantProps
})